import { useGate, useUnit } from 'effector-react';
import {
  Autocomplete,
  AutocompleteProps,
  CircularProgress,
  FormControl,
  FormHelperText,
  FormLabel,
} from '@mui/material';
import TextField from '@mui/material/TextField';
import { Listbox } from '@features/effector-form/components/listbox';
import { withControl } from '@features/effector-form/hoc/withControl';
import { ControlGate, dataQuery } from './model';
import { Option } from './types';

export const TimezoneControl = withControl<
  Partial<AutocompleteProps<any, any, any, any>>
>(
  ({
    label,
    value,
    setValue,
    error,
    required,
    readOnly,
    disabled,
    multiple,
    clearIcon,
  }) => {
    useGate(ControlGate);

    const { data, pending } = useUnit(dataQuery);

    const handleChange = (event: any, newValue: any) => {
      if (multiple) {
        setValue(newValue.map((item: Option) => item.id) || null);
      } else {
        setValue(newValue?.id || null);
      }
    };

    const getValue = () => {
      if (value === null) return value;

      if (!data && multiple) return [];
      if (!data && !multiple) return null;

      return multiple
        ? data?.filter((item) => value?.indexOf(item.id) > -1)
        : data?.find((item) => item.id === value);
    };

    return (
      <FormControl>
        <FormLabel required={required}>{label}</FormLabel>

        <Autocomplete
          loading={pending}
          value={getValue()}
          options={!data ? [] : data}
          onChange={handleChange}
          slotProps={{
            listbox: {
              component: Listbox,
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              slotProps={{
                input: {
                  ...params.InputProps,
                  required,
                  readOnly,
                  disabled,
                  endAdornment:
                    pending && !readOnly ? (
                      <CircularProgress size={20} color="inherit" />
                    ) : (
                      params.InputProps.endAdornment
                    ),
                },
              }}
            />
          )}
          readOnly={readOnly}
          disabled={disabled}
          multiple={multiple}
          clearIcon={clearIcon}
        />
        <FormHelperText error>{error}</FormHelperText>
      </FormControl>
    );
  }
);
